import React, { useState } from 'react';
import {
  Card, Typography, TextField, Button, Table, TableHead,
  TableRow, TableCell, TableBody, Paper
} from '@mui/material';
import axios from 'axios';

export default function AdminQueryBuilder() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState({ columns: [], rows: [] });
  const [error, setError] = useState(null);

  const runQuery = async () => {
    try {
      const res = await axios.post('/api/admin/sql-query/', { query });
      setResults(res.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Unknown error');
    }
  };

  return (
    <Card sx={{ padding: 4, backgroundColor: '#1e1e1e', color: 'white' }}>
      <Typography variant="h5" gutterBottom>Raw SQL Query Runner</Typography>
      <TextField
        multiline
        minRows={6}
        fullWidth
        variant="outlined"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="SELECT * FROM users LIMIT 10"
        InputProps={{ style: { color: 'white', backgroundColor: '#2c2c2c' } }}
        InputLabelProps={{ style: { color: '#ccc' } }}
      />
      <Button onClick={runQuery} variant="contained" sx={{ mt: 2, backgroundColor: '#1E90FF' }}>
        Run Query
      </Button>

      {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}

      {results.rows.length > 0 && (
        <Paper sx={{ mt: 4, backgroundColor: '#2b2b2b', overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                {results.columns.map((col, i) => (
                  <TableCell key={i} sx={{ color: 'white' }}>{col}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {results.rows.map((row, i) => (
                <TableRow key={i}>
                  {row.map((val, j) => (
                    <TableCell key={j} sx={{ color: 'white' }}>{val}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Card>
  );
}